// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sTBl","list":"styles_list__2Ty1B","disableSelection":"styles_disableSelection__ywer3"};